import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  granolaService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface GranolaPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function GranolaPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: GranolaPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="granola"
      displayName="Granola"
      description="Connect your Granola account to access your meeting notes and transcripts directly in conversations."
      features={[
        'Access to your meeting notes',
        'Search through past meetings',
        'Meeting transcripts (Granola Pro)',
        'AI-powered meeting insights',
      ]}
      accentColor="purple"
      events={{
        modalOpened: OnboardingEvents.GRANOLA_MODAL_OPENED,
        oauthStarted: OnboardingEvents.GRANOLA_OAUTH_STARTED,
        connected: OnboardingEvents.GRANOLA_CONNECTED,
        connectionFailed: OnboardingEvents.GRANOLA_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.GRANOLA_MODAL_CLOSED,
      }}
      service={granolaService}
    />
  );
}
